export enum ReplenishmentDestinationType {
  ALL = "ALL",
  FBA = "FBA",
  WFS = "WFS",
  FLEXPORT_ECOM = "FLEXPORT_ECOM",
}
